import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadReleaseAtom = createMutationAtomFactory(
  'trade.purchaseLoadRelease',
  (params: { id: string }) => ({
    tradePurchaseLoadRelease: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
